<template>
  <nav class="flex flex-col">
    <Medias v-if="data.sc_medias" :medias="data.sc_medias" />
    <Menu />
  </nav>
</template>

<script>
import Medias from "./nav/Medias";
import Menu from "./nav/Menu";
export default {
  props: { data: Object },
  components: { Medias, Menu },
};
</script>

<style>
nav .menu.sticky {
  position: fixed;
  top: 0;
  border: none;
  z-index: 1;
  border-radius: 5px;
  background: var(--transparent);
}
nav {
  width: 100%;
}
nav .sc-medias {
  margin-top: 1.5rem;
}
nav .menu {
  padding: 1rem 0;
  padding-bottom: 1.5rem;
  margin-top: 1px;
}
nav li {
  display: inline-block;
}
nav i.icon {
  font-size: 2rem;
  color: var(--grey);
  margin-right: 1rem;
}
nav .nav-link {
  padding: 0.5rem 1rem;
  font-size: 19px;
  margin: 0 0.5rem;
  color: var(--dark);
  border-radius: 2px;
  letter-spacing: 1px;
  transition-duration: 0.6s;
  text-transform: capitalize;
  border-bottom: 3px solid var(--secondary);
}
.sticky .nav-link {
  color: var(--light);
}
nav .sticky .nav-link {
  color: var(--light);
}
nav .nav-link:hover,
nav .sticky .nav-link:hover {
  padding: 1.3rem 1rem;
  border-color: var(--gradient);
  color: var(--primary);
}
nav .router-link-active,
nav .sticky .router-link-active {
  font-weight: bold;
  border-color: var(--primary);
  color: var(--primary);
}
@media screen and (max-width: 520px) {
  nav .menu.sticky {
    width: 100%;
    border-radius: 0;
    margin: 0;
  }
  nav .nav-link {
    padding: 0.5rem;
    font-size: 1rem;
    margin: 0 0.5rem;
    letter-spacing: 1px;
  }
}
</style>
